import JSZip from 'jszip'

export interface NamedFile {
  filename: string
  blob: Blob
}

// "Doc.docx" -> "Doc (2).docx"; names without an extension get the suffix at
// the end.
const withSuffix = (filename: string, n: number): string => {
  const dot = filename.lastIndexOf('.')
  return dot > 0
    ? `${filename.slice(0, dot)} (${n})${filename.slice(dot)}`
    : `${filename} (${n})`
}

/**
 * The zip entry names for `filenames`, in order: a name already taken gets the
 * first free " (2)", " (3)", … suffix, so no file overwrites another.
 */
export const uniqueFilenames = (filenames: string[]): string[] => {
  const taken = new Set<string>()
  return filenames.map((filename) => {
    let unique = filename
    for (let n = 2; taken.has(unique); n++) {
      unique = withSuffix(filename, n)
    }
    taken.add(unique)
    return unique
  })
}

/** Packs the files into one zip, each under its own (deduplicated) name. */
export const packDocsZip = async (files: NamedFile[]): Promise<Blob> => {
  const zip = new JSZip()
  const names = uniqueFilenames(files.map((file) => file.filename))
  files.forEach((file, index) => {
    zip.file(names[index], file.blob)
  })
  return zip.generateAsync({ type: 'blob' })
}
